import React, { useState, useEffect, useRef } from "react";
import userImg from "../assets/userimage.png";

const ProfileInput = (props) => {
  const [image, setImage] = useState(props.image || userImg);
  const hasChanged = useRef(false); // Tracks if user changed the image manually

  useEffect(() => {
    if (props.image && !hasChanged.current) {
      setImage(props.image);
    }
  }, [props.image]);

  const handleClick = () => {
    document.getElementById("profile-image-upload").click();
  };

  const handleFileChange = (event) => {
    if (event && event.target.files.length > 0) {
      const selectedFile = event.target.files[0];
      const objectURL = URL.createObjectURL(selectedFile);

      hasChanged.current = true; // Mark as manually changed
      setImage(objectURL); // Show new image
      props.handleProfilePic(selectedFile); // Pass file to parent
    }
  };

  return (
    <div className="profile-pic">
      <img
        onClick={handleClick}
        alt="User Pic"
        src={image}

        id="profile-image1"
        width="150"
        height="150"
        className="upload-img"
      />

      <input
        accept="image/*"
        type="file"
        disabled={props.isDisabled}
        id="profile-image-upload"
        onChange={handleFileChange}
        style={{ display: "none" }}
      />

      <button type="button" onClick={handleClick} className="custom-btn mt-2">
        Upload Image<span className="required">*</span>
      </button>
    </div>
  );
};

export default ProfileInput;
